import { IllegalArgumentError } from 'faro-common-model';
import { sortableEntitySchema } from './sortable-entity.js';
import { StudyEntityType } from './study-entity-type.js';
import { z } from 'zod';
import { uuidish } from '../utils/uuidish.js';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
export const activityPlaceholderNameMaxLength = 255;
export const activitySchema = z.object({
    ...sortableEntitySchema.shape,
    entityType: z.literal(StudyEntityType.Activity).default(StudyEntityType.Activity),
    scheduleOfActivitiesId: uuidish,
    activityGroupId: uuidish,
    assessmentMeasurementConfigurationId: uuidish.nullish().transform(nullishToUndefined).optional(),
    placeholderName: z
        .string()
        .max(activityPlaceholderNameMaxLength)
        .nullish()
        .transform(nullishToUndefined)
        .optional(),
    name: z.transform(val => val !== null && val !== void 0 ? val : '').pipe(z.string()),
});
export function toActivity(activity) {
    const result = activitySchema.safeParse(activity);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid Activity object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=activity.js.map